export enum EmployeeGenderEnum {
  Female = "female",
  Male = "male",
}

export const employeeGenderOptions = [
  { value: "", label: "Not specified" },
  { value: EmployeeGenderEnum.Female, label: "Female" },
  { value: EmployeeGenderEnum.Male, label: "Male" },
];

export const normalizeEmployeeGender = (
  value: unknown,
): EmployeeGenderEnum | null => {
  switch (String(value ?? "").trim().toLowerCase()) {
    case "female":
    case "1":
      return EmployeeGenderEnum.Female;
    case "male":
    case "2":
      return EmployeeGenderEnum.Male;
    default:
      return null;
  }
};

export const employeeGenderLabel = (value: unknown): string => {
  const gender = normalizeEmployeeGender(value);
  return employeeGenderOptions.find((option) => option.value === gender)?.label
    ?? "Not specified";
};
